<ng-template #completeInfoModal let-modal>
    <div class="modal-head">
        <button class="btn btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
        <div class="img-wrap">
            <img src="./assets/images/ic-com-info.svg" alt="Icon">
        </div>
        <h2 class="title-text" ngbAutofocus>Complete Information</h2>
        <h5 class="info-text">
            Business registration needs to be completed prior to adding images or products, please complete Main
            Information and
            Details before proceeding
        </h5>
        <div class="btn-grps">
            <button class="btn btn-outline-primary" title="Okay" (click)="modal.close('Close click');">Okay</button>
        </div>
    </div>
</ng-template>